import React from "react";
import { ValidatedInput } from '../ValidatedInput.js/ValidatedInput';

import { alphanumericValidator, customRegexValidator, ROLE_NAME_REGEX } from '../../validators/InputValidator';


export default function RoleInformation(props) {
    const { roleName, description, errors, setErrors, handleFieldUpdate, readOnly} = props;

    const handleInputChange = (errorKey, inputValue, valueSetter, validator, regex) => {
        let validationError;
        if (validator) {
            validationError = validator(inputValue, regex)
        }

        valueSetter(errorKey, inputValue);

        if (validationError) {
            setErrors({ ...errors, [errorKey]: validationError });
        } else {
            setErrors(current => {
                // create copy of error state
                const copy = { ...current };
                // remove error key from object
                delete copy[errorKey];
                return copy;
            });
        }
    }

    return (
        <><div className="row">
            <div className="col">
                <ValidatedInput
                    label="Role Name*"
                    errorKey="roleName"
                    formName="roleInfo"
                    maxLength={50}
                    value={roleName}
                    readOnly={readOnly}
                    valueSetter={handleFieldUpdate}
                    validator={customRegexValidator}
                    regex={ROLE_NAME_REGEX}
                    onChange={handleInputChange}
                    errors={errors?.roleName}
                />
                <ValidatedInput
                    label="Description (optional)"
                    errorKey="description"
                    formName="roleInfo"
                    maxLength={256}
                    value={description}
                    readOnly={readOnly}
                    valueSetter={handleFieldUpdate}
                    validator={alphanumericValidator}
                    onChange={handleInputChange}
                    errors={errors?.description}
                    isTextBox={true}
                />
            </div>
            <div className="col">
            </div>
        </div></>
    );
}